import React from 'react';

import env from '@config/env';
import * as Sentry from '@sentry/react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

const tracesSampleRate = Number(env.SENTRY_TRACES_SAMPLE_RATE || '0.2');
const replaysSessionSampleRate = Number(env.SENTRY_REPLAY_SESSION_SAMPLE_RATE || '0.1');
const replaysOnErrorSampleRate = Number(env.SENTRY_REPLAY_ERROR_SAMPLE_RATE || '1.0');

const reactRouterIntegration = Sentry.reactRouterV6BrowserTracingIntegration({
  useEffect: React.useEffect,
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
});

Sentry.init({
  dsn: env.SENTRY_DSN,
  environment: env.SENTRY_ENVIRONMENT || process.env.NODE_ENV,
  release: env.SENTRY_RELEASE,
  integrations: [
    Sentry.browserTracingIntegration(),
    reactRouterIntegration,
    Sentry.replayIntegration(),
  ],
  tracesSampleRate,
  replaysSessionSampleRate,
  replaysOnErrorSampleRate,
  sendDefaultPii: true,
});

if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) => {
    Sentry.withScope((scope) => {
      scope.setContext('unhandledrejection', {
        reason: event.reason,
      });
      Sentry.captureException(event.reason || 'Unhandled promise rejection');
    });
  });

  window.addEventListener('error', (event) => {
    Sentry.withScope((scope) => {
      scope.setContext('error', {
        message: event.message,
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
      });
      Sentry.captureException(event.error || event.message);
    });
  });

  const sentryAny = Sentry as any;
  if (typeof sentryAny.metricsInstrument === 'function') {
    sentryAny.metricsInstrument();
  }
}
